const messages = {
  en: {
    register: 'Register',
    join_now: 'Join Now',
    select_stream_below: 'Please select preferred stream below',
    please_write_your_question: 'Please write your question',
    change: 'Change',
    save: 'Save',
    cancel: 'Cancel',
    send: 'Send',
    sending: 'Sending...',
    name: 'Name',
    okey: 'Okey',
    city_or_country: 'City or Country',
    please_register: 'Registration',
    please_wait: 'Please wait',
    please_enter_your_name: 'Please enter your name and location before sending a question.',
    hide_questions: 'Questions are only visible to speaker',
    add_to_calendar: 'Add to Calendar',
    livecast_will_start_in: 'Livecast will start {time}',
    form_validation_error: 'Validation Error',
    registration_form_error: 'Please fix errors on registration form.',
    send_question_success: 'Your question has been sent.',
    send_question_error: 'Error sending question!',
    required_field_error: 'This field is required',
    invalid_field_error: 'invalid {fieldName} format',
    regform_selectBoxOther: 'Other',
    thanks_for_registering: 'Thanks for registering!',
    confirmation_mail_sent: 'A confirmation email with webcast link has been sent to your email address.',
    join_15_min_before: 'Please use the link 15 min. join to the webcast'

  }
}

export default messages